import {
  useAppSelector,
  useGetEntitlementsQuery,
  userPermissionCheck
} from '@monorepo/shared';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { CSSProperties, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Stack } from 'rsuite';
import { AssetList } from './AssetList';
import { InstanceList } from './InstanceList';
import { HomeElms, server } from '../../config/const';
import BlockIcon from '@rsuite/icons/Block';

export const AccountDetail = () => {
  const { groupId } = useParams();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [account, setAccount] = useState<Record<string, any>>({});
  const [isAuth, setIsAuth] = useState<boolean>(true);
  const { data: assets, isSuccess: isAssetSuccess } = useGetEntitlementsQuery(
    {
      server: server,
      account_id: currentAccount.account_id,
      group_id: groupId
    },
    { skip: !currentAccount.account_id }
  );
  useEffect(() => {
    if (currentAccount?.account_id) {
      const region = currentAccount?.region || [];
      const regionArr = Array.isArray(region) ? region : [region];
      setAccount({
        ...currentAccount,
        regionStr: Array.from(
          new Set(
            regionArr.map((obj: Record<string, any>) => {
              return [obj.name, obj.alias].join('|');
            })
          )
        )
      });
      const isAuthPassed =
        !!groupId || userPermissionCheck(currentAccount, HomeElms?.fcName);
      setIsAuth(isAuthPassed);
    }
  }, [currentAccount]);

  useEffect(() => {
    if (!isAuth && currentAccount?.account_id) {
      if (currentAccount?.user_auth_url) {
        console.info(
          'Account does not have permission, redirecting to user auth URL...',
          currentAccount.user_auth_url
        );
        window.location.href = currentAccount.user_auth_url;
      }
    }
  }, [isAuth, currentAccount]);

  useEffect(() => {
    if (isAssetSuccess) {
      if (!assets?.entitlements?.length) {
        setIsAuth(false);
      }
    }
  }, [assets]);

  return (
    <div className="account-detail-container">
      {isAuth ? (
        <>
          <div className="grid-container row">
            {/* account information */}
            <div className="grid-item account-info ">
              <div className="grid-header">
                <div className="title">
                  <i className="icon-fortinetone-productList"></i>
                  Account Information
                </div>
              </div>
              <div className="grid-content">
                <div className="info-list">
                  {Object.keys(account)
                    .filter((key) => Object.keys(accountCols).includes(key))
                    .map((key: string, index: number) => {
                      return (
                        <Stack
                          key={index}
                          alignItems="flex-start"
                          style={{ marginBottom: '5px' }}
                        >
                          <Stack.Item className="list-type">
                            {accountCols[key]}
                          </Stack.Item>
                          <Stack.Item className="list-content" grow={1}>
                            {key === 'regionStr' &&
                            Array.isArray(account[key]) ? (
                              <ul style={{ paddingLeft: '14px' }}>
                                {account[key]?.map(
                                  (value: string, index: number) => {
                                    const arr = value?.split('|');
                                    const alias = arr[1] || '';
                                    const name = arr[0] || '';
                                    return (
                                      <li key={index}>
                                        <Link
                                          key={index}
                                          to={`region/${alias}`}
                                        >
                                          {name}
                                        </Link>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            ) : (
                              <>{account[key]}</>
                            )}
                          </Stack.Item>
                        </Stack>
                      );
                    })}
                </div>
              </div>
            </div>
            <AssetList />
          </div>
          <div className="grid-container place-holder">
            <InstanceList />
          </div>
        </>
      ) : (
        <div style={{ display: 'grid', placeItems: 'center', height: '80%' }}>
          <Stack
            spacing={'30px'}
            alignItems="center"
            className="account-info-container"
          >
            <Stack.Item alignSelf="flex-start">
              <BlockIcon color="red" style={{ fontSize: '2em' }} />
            </Stack.Item>
            <Stack.Item flex={1} className="info-content">
              <div
                style={{
                  marginBottom: '20px',
                  fontSize: '1.2em',
                  fontWeight: '700'
                }}
              >
                {`No ${HomeElms?.name} Subscription`}
              </div>
              <div className="info-row" style={{ color: '#B0B0B0' }}>
                <div>
                  {`Your account does not have a valid ${HomeElms?.name} subscription.`}
                </div>
                <div>{'Please purchase a subscription to continue.'}</div>
              </div>
            </Stack.Item>
          </Stack>
        </div>
      )}
    </div>
  );
};

const accountCols: Record<string, string> = {
  account_company: 'Company',
  account_id: 'Account ID',
  master_user_name: 'Owner',
  account_name: 'Account Name',
  account_email: 'Account Email',
  regionStr: 'Service Regions'
};

export const styleCenter: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

export const flexColumn: CSSProperties = {
  ...styleCenter,
  flexDirection: 'column'
};

export const styleCenterWithHeight: CSSProperties = {
  ...styleCenter,
  height: '60px'
};

export const columnLeft: CSSProperties = {
  ...flexColumn,
  alignItems: 'flex-start'
};
export const columnLeftWithHeight: CSSProperties = {
  ...columnLeft,
  height: '60px',
  overflow: 'hidden'
};

export const slimText: CSSProperties = {
  fontSize: '10px',
  opacity: 0.9,
  fontWeight: '400',
  paddingBottom: 5,
  overflow: 'hidden',
  whiteSpace: 'nowrap'
};

export const titleStyle: CSSProperties = {
  // paddingBottom: 5,
  whiteSpace: 'nowrap'
};

export const dataStyle: CSSProperties = {
  fontSize: '12px',
  fontWeight: 500,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  minHeight: '16px'
};

export const textStyle: CSSProperties = {
  fontSize: '16px',
  fontWeight: 500
};
export const subTitleStyle: CSSProperties = {
  paddingBottom: 5,
  whiteSpace: 'nowrap',
  fontWeight: 400,
  fontSize: '0.8em',
  opacity: 0.8
};
